<template>
        <div class="profile-settings-password">
            <span class="profile-settings-password__heading">Şifre ayarların</span>
            <span class="profile-settings-password__description">Şifreni değiştirebilir ya da yeni bir tane talep edebilirsin.</span>
            <span class="profile-settings-password__art-separator"></span>
            <Preloader
                v-if="show.preloader"
                preloaderText="Yükleniyor"/>
            <div class="profile-settings-password-change" v-if="show.passwordChange">
                <span class="profile-settings-password-change__heading">Şifre Değişikliği</span>
                <div class="profile-settings-password-change-wr-label-input">
                    <label class="profile-settings-password-change__label" for="profile-settings-password-change__old-pass">Eski şifre</label>
                    <div class="profile-settings-password-change-wr-input">
                        <input
                            class="profile-settings-password-change__inp-pass"
                            id="profile-settings-password-change__old-pass"
                            type="password"
                            placeholder="••••••"
                            @input="inputPassOld"
                            @keyup.enter="$store.state.envDev == true ? confirmPassChange() : confirmPassChangeApi()">
                        <svg class="profile-settings-password-change__inp-pass-icon" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_64_254)"><path d="M7.2 10v1.6m-4-5.177c.378-.023.843-.023 1.44-.023h5.12c.599 0 1.064 0 1.44.023m-8 0c-.47.029-.804.093-1.089.239A2.4 2.4 0 001.062 7.71c-.261.514-.261 1.186-.261 2.53v1.12c0 1.344 0 2.016.261 2.53a2.4 2.4 0 001.05 1.048c.513.262 1.185.262 2.529.262h5.12c1.344 0 2.016 0 2.53-.262a2.4 2.4 0 001.048-1.048c.262-.514.262-1.186.262-2.53v-1.12c0-1.344 0-2.016-.262-2.53a2.4 2.4 0 00-1.049-1.048c-.285-.146-.619-.21-1.09-.239m-8 0V4.8a4 4 0 018 0v1.623" stroke="#AAA" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_64_254"><path fill="#fff" d="M0 0h14.4v16H0z"/></clipPath></defs></svg>
                    </div>
                </div>

                <div class="profile-settings-password-change-wr-label-input">
                    <label class="profile-settings-password-change__label" for="profile-settings-password-change__new-pass">Yeni şifre</label>
                    <div class="profile-settings-password-change-wr-input">
                        <input
                            v-if="!show.inpRevealedPass"
                            class="profile-settings-password-change__inp-pass"
                            id="profile-settings-password-change__new-pass"
                            type="password"
                            :value="$store.state.input.profile.passNew"
                            @input="inputPassNew"
                            @keyup.enter="$store.state.envDev == true ? confirmPassChange() : confirmPassChangeApi()">
                        <input
                            v-if="show.inpRevealedPass"
                            class="profile-settings-password-change__inp-pass"
                            id="profile-settings-password-change__new-pass"
                            type="text"
                            :value="$store.state.input.profile.passNew"
                            @input="inputPassNew"
                            @keyup.enter="$store.state.envDev == true ? confirmPassChange() : confirmPassChangeApi()">
                        <svg class="profile-settings-password-change__inp-pass-icon" width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_64_254)"><path d="M7.2 10v1.6m-4-5.177c.378-.023.843-.023 1.44-.023h5.12c.599 0 1.064 0 1.44.023m-8 0c-.47.029-.804.093-1.089.239A2.4 2.4 0 001.062 7.71c-.261.514-.261 1.186-.261 2.53v1.12c0 1.344 0 2.016.261 2.53a2.4 2.4 0 001.05 1.048c.513.262 1.185.262 2.529.262h5.12c1.344 0 2.016 0 2.53-.262a2.4 2.4 0 001.048-1.048c.262-.514.262-1.186.262-2.53v-1.12c0-1.344 0-2.016-.262-2.53a2.4 2.4 0 00-1.049-1.048c-.285-.146-.619-.21-1.09-.239m-8 0V4.8a4 4 0 018 0v1.623" stroke="#AAA" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_64_254"><path fill="#fff" d="M0 0h14.4v16H0z"/></clipPath></defs></svg>
                        <button class="profile-settings-password-change-btn-show" @click="show.inpRevealedPass=true" v-if="!show.inpRevealedPass">
                            <svg class="profile-settings-password-change-btn-show__icon" width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_5_2571)"><path d="M1.69.705a.75.75 0 10-1.38.59l1.38-.59zm6.352 7.033a.75.75 0 10-1.258-.818l1.258.818zM5.372 9.09a.75.75 0 101.257.818l-1.257-.818zM21.69 1.295a.75.75 0 00-1.38-.59l1.38.59zM18.97 7.16a.75.75 0 101.06-1.06l-1.06 1.06zM10.25 10.5a.75.75 0 001.5 0h-1.5zm5.122-.591a.75.75 0 101.257-.818l-1.257.818zM4.53 5.659A.75.75 0 003.47 4.6l1.06 1.06zM1.97 6.1a.75.75 0 001.06 1.06L1.97 6.1zM11 7.25c-3.224 0-5.538-1.605-7.075-3.26a13.637 13.637 0 01-1.702-2.28 11.708 11.708 0 01-.507-.946 3.903 3.903 0 01-.026-.06L1 1l-.69.295.001.002.001.002.003.006a3.837 3.837 0 00.04.088 13.202 13.202 0 00.58 1.084c.41.69 1.034 1.61 1.89 2.533C4.54 6.855 7.226 8.75 11 8.75v-1.5zm3.313-.62c-.97.383-2.071.62-3.313.62v1.5c1.438 0 2.725-.276 3.862-.723l-.55-1.396zm-7.529.29L5.372 9.09l1.257.818 1.413-2.171-1.258-.818zM21 1l-.69-.295.001-.001v.002l-.007.013a8.015 8.015 0 01-.152.313 13.298 13.298 0 01-2.666 3.55l1.027 1.094a14.802 14.802 0 003.122-4.26l.039-.085.01-.024.004-.007v-.003l.002-.002L21 1zm-3.513 3.582c-.86.806-1.913 1.552-3.174 2.049l.55 1.396c1.473-.58 2.684-1.444 3.65-2.351l-1.026-1.094zm-.017 1.077l1.5 1.5 1.06-1.06-1.5-1.5-1.06 1.06zM10.25 8v2.5h1.5V8h-1.5zm3.709-.262l1.413 2.171 1.257-.818-1.413-2.171-1.257.818zm-10.49-3.14l-1.5 1.5L3.032 7.16l1.5-1.5L3.47 4.6z" fill="#AAA"/></g><defs><clipPath id="clip0_5_2571"><path fill="#fff" d="M0 0h22v12H0z"/></clipPath></defs></svg>
                        </button>
                        <button class="profile-settings-password-change-btn-hide" @click="show.inpRevealedPass=false" v-if="show.inpRevealedPass">
                            <svg class="profile-settings-password-change-btn-hide__icon" width="13" height="10" viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_64_263)"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.8l2.464-2.956a5.124 5.124 0 017.872 0L12.8 4.8l-2.464 2.956a5.124 5.124 0 01-7.872 0L0 4.8zm6.4 2.4a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z" fill="#000"/></g><defs><clipPath id="clip0_64_263"><path fill="#fff" d="M0 0h12.8v9.6H0z"/></clipPath></defs></svg>
                        </button>
                    </div>
                </div>

                <div class="profile-settings-password-change-wr-buttons">
                    <button
                        class="profile-settings-password-change-btn-forgot"
                        @click="$store.state.envDev == true ? requestPasswordReset() : requestPasswordResetApi()">
                        <span class="profile-settings-password-change-btn-forgot__text">Şifremi Unuttum</span>
                    </button>
                    <button
                        class="profile-settings-password-change-btn-confirm"
                        @click="$store.state.envDev == true ? confirmPassChange() : confirmPassChangeApi()">
                        <span class="profile-settings-password-change-btn-confirm__text">Onayla</span>
                    </button>
                </div>
            </div>
            <div class="profile-settings-password-confirm" v-if="show.passwordConfirm">
                <span class="profile-settings-password-confirm__heading">Şifre Değişikliği</span>
                <span class="profile-settings-password-confirm__description">{{ this.$store.state.userSession.email }} adresine gelen onay kodunu girerek şifre değişikliğini onaylayabilirsin.</span>
                <span class="profile-settings-password-confirm__time">Kalan Süre: {{ expireTime }}</span>
                <div class="profile-settings-password-confirm-form">
                    <label class="profile-settings-password-confirm-form__label">Onay Kodu</label>
                    <input
                        class="profile-settings-password-confirm-form__inp-text"
                        @input="inputEmailCode">
                    <input
                        class="profile-settings-password-confirm-form__inp-text"
                        @input="inputEmailCode">
                    <input
                        class="profile-settings-password-confirm-form__inp-text"
                        @input="inputEmailCode">
                    <input
                        class="profile-settings-password-confirm-form__inp-text"
                        @input="inputEmailCode">
                    <button
                        class="profile-settings-password-confirm-form-btn-confirm"
                        @click="$store.state.envDev == true ? confirmEmailCode() : confirmEmailCodeApi()">
                        <span class="profile-settings-password-confirm-form-btn-confirm__text">Onayla</span>
                    </button>
                </div>
            </div>
            <div
                v-if="show.passwordSuccess"
                class="profile-settings-password-success">
                <span class="profile-settings-password-success__art-success"></span>
                <span class="profile-settings-password-success__heading">Başarılı</span>
                <span class="profile-settings-password-success__text">Şifren başarıyla değiştirildi.</span>
            </div>
            <div
                v-if="show.passwordForgot"
                class="profile-settings-password-forgot">
                <span class="profile-settings-password-forgot__heading">Şifre Sıfırlama</span>
                <span class="profile-settings-password-forgot__description">{{ this.$store.state.userSession.email }} adresine gelen bağlantıyı kullanarak şifreni sıfırlayabilirsin.</span>
                <div class="profile-settings-password-forgot-notification">
                    <svg class="profile-settings-password-forgot-notification__art-mail-sent" width="51" height="47" viewBox="0 0 51 47" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_144_20178)" fill="#AED0DF"><path d="M10.187 23.782c-.251 2.51.753 4.769 2.259 6.526l8.031 8.031c1.506 1.506 3.514 2.51 5.773 2.51 2.258 0 4.266-.753 5.772-2.51l16.063-16.063c1.506-1.505 2.51-3.513 2.51-5.772 0-2.259-.753-4.267-2.51-5.773l-8.032-8.03C38.297.942 36.038.19 33.529.44c-2.008.251-3.765 1.004-5.02 2.26L12.697 18.762c-1.506 1.255-2.26 3.262-2.51 5.02zM30.767 7.72l-1.255 10.039c-.25 1.255-1.004 2.008-2.259 2.259l-10.039 1.255L30.767 7.72zm-2.76 17.066c3.513-.502 6.274-3.011 6.525-6.525l1.506-12.298c.25 0 .25.25.502.25l8.031 8.032a3.181 3.181 0 010 4.518L28.508 34.825a3.181 3.181 0 01-4.517 0l-7.78-8.03c-.252-.252-.252-.503-.503-.503l12.298-1.506zM3.412 44.363c.753 0 1.255-.251 1.757-.753l7.53-7.53c1.003-1.003 1.003-2.51 0-3.513-1.005-1.004-2.51-1.004-3.514 0l-7.53 7.53c-1.004 1.003-1.004 2.509 0 3.513.502.502 1.004.753 1.757.753zM15.208 46.12l2.51-2.51c1.004-1.004 1.004-2.51 0-3.514s-2.51-1.004-3.514 0l-2.51 2.51c-1.004 1.004-1.004 2.51 0 3.514.502.502 1.004.753 1.757.753.753 0 1.255-.251 1.757-.753z"/></g><defs><clipPath id="clip0_144_20178"><path fill="#fff" d="M0 0h51v47H0z"/></clipPath></defs></svg>
                    <span class="profile-settings-password-forgot-notification__heading">Mail Yolda</span>
                    <span class="profile-settings-password-forgot-notification__text">Şifre sıfırlama bağlantısını gönderdik.</span>
                </div>
            </div>
        </div>
</template>
<script>
    import Preloader from '@/components/Preloader.vue';
    export default {
        components: {
            Preloader,
        },

        data(){
            return {
                show: {
                    preloader: false,
                    passwordChange: true,
                    passwordConfirm: false,
                    passwordSuccess: false,
                    passwordForgot: false,
                    inpRevealedPass: false,
                },
                intervals: {
                    emailConfirmation: null,
                },
                expireTime: '',
            };
        },

        methods: {
            te(event){
                console.log(event.currentTarget.parentElement);
            },

            startTimer(){
                let expireTime;
                if(this.$store.state.envDev){
                    expireTime = Math.floor(Date.now() / 1000) + 300;
                }
                else{
                    expireTime = this.$store.state.response.profile.passwordChangeRequestData.expireTime;
                }

                this.intervals.emailConfirmation = setInterval(() => {
                    let currentTime = Math.floor(Date.now() / 1000);
                    let timediff = expireTime - currentTime;
                    let minsdiff = Math.floor(timediff / 60);
                    let secsdiff = Math.floor(timediff % 60);

                    if(timediff <= 0){
                        clearInterval(this.intervals.emailConfirmation);
                        this.expireTime = '00:00';
                        return;
                    }

                    if(minsdiff < 10){
                        minsdiff = '0' + minsdiff;
                    }
                    if(secsdiff < 10){
                        secsdiff = '0' + secsdiff;
                    }

                    this.expireTime = `${minsdiff}:${secsdiff}`;
                }, 250);
            },
            
            inputPassOld(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'profile',
                    dataLabel: 'passOld',
                    data: event.target.value,
                });
            },

            inputPassNew(event){
                this.$store.commit('setInput', {
                    categoryLabel: 'profile',
                    dataLabel: 'passNew',
                    data: event.target.value,
                });
            },

            confirmPassChange(event){
                if(this.$store.state.input.profile.passOld.length < 3){
                    this.$foneturkError({
                        text: 'Eski şifren en az 3 karakter olmalı.'
                    });
                    return;
                }
                if(this.$store.state.input.profile.passNew.length < 3){
                    this.$foneturkError({
                        text: 'Yeni şifren en az 3 karakter olmalı.'
                    });
                    return;
                }

                this.show.preloader = true;
                this.show.passwordChange = false;

                fetch(this.$store.state.jsonServer.passwordChange)
                .then(response => {
                    this.show.preloader = false;
                    return response.json();
                })
                .then(passwordChangeData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'profile',
                        dataLabel: 'passwordChangeData',
                        data: passwordChangeData
                    })
                    if(passwordChangeData.result == true){
                        this.show.passwordConfirm = true;
                        let expireTime = Math.floor(Date.now() / 1000) + 300;
                        this.intervals.emailConfirmation = setInterval(() => {
                            let currentTime = Math.floor(Date.now() / 1000);
                            let timediff = expireTime - currentTime;
                            let minsdiff = Math.floor(timediff / 60);
                            let secsdiff = Math.floor(timediff % 60);

                            if(timediff <= 0){
                                clearInterval(this.intervals.emailConfirmation);
                            }

                            if(minsdiff < 10){
                                minsdiff = '0' + minsdiff;
                            }
                            if(secsdiff < 10){
                                secsdiff = '0' + secsdiff;
                            }

                            this.expireTime = `${minsdiff}:${secsdiff}`;
                        }, 250);
                    }
                    else{
                        this.show.passwordChange = true;
                        this.show.passwordConfirm = false;
                    }
                });
            },

            confirmPassChangeApi(){
                if(this.$store.state.input.profile.passOld.length < 3){
                    this.$foneturkError({
                        text: 'Eski şifren en az 3 karakter olmalı.'
                    });
                    return;
                }
                if(this.$store.state.input.profile.passNew.length < 3){
                    this.$foneturkError({
                        text: 'Yeni şifren en az 3 karakter olmalı.'
                    });
                    return;
                }

                this.show.preloader = true;
                this.show.passwordChange = false;

                let passwordChangeOptions = {
                    passwordOld: this.$store.state.input.profile.passOld,
                    passwordNew: this.$store.state.input.profile.passNew
                };
                

                fetch(this.$store.state.api.requestPasswordChange, {
                    method: 'POST',
                    credentials: "include",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `passwordChangeOptions=${JSON.stringify(passwordChangeOptions)}`
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(passwordChangeRequestData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'profile',
                        dataLabel: 'passwordChangeRequestData',
                        data: passwordChangeRequestData
                    });
                    if(passwordChangeRequestData.result){
                        this.show.passwordConfirm = true;
                        this.startTimer();
                    }
                })
                .catch(err => {
                    if(err.code == 'REQUEST_PASSWORD_CHANGE_MODEL/RUN::INV_USER_SESSION'){
                        this.$foneturkError({
                            text: 'Önce giriş yapmalısın',
                            didClose: () => {
                                this.$router.push('/login');
                            }
                        });
                    }
                    else if(err.code == 'REQUEST_PASSWORD_CHANGE_MODEL/RUN::OLD_PASSWORD_NOT_SAME'){
                        this.$foneturkError({
                            text: 'Girdiğin eski şifreyle şimdiki şifren uyuşmuyor.'
                        });
                    }
                    else{
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti.'
                        });
                    }
                    this.show.passwordChange = true;
                })
            },



            inputEmailCode(event){
                // If element has already an existing num value, replace it with entered one.
                if(event.currentTarget.value){
                    event.currentTarget.value = event.data;
                }

                // Remove error class from previous attempts.
                document.querySelector('.profile-settings-password-confirm').classList.remove('profile-settings-password-confirm--error');

                // Change focus to the next input element.
                if(event.currentTarget.nextSibling.classList.contains('profile-settings-password-confirm-form__inp-text')){
                    event.currentTarget.nextSibling.focus();
                }

                // Concatenate all the number inputs and update vuex state.
                let concatenatedValue = "";
                document.querySelectorAll('.profile-settings-password-confirm-form__inp-text').forEach((el) => {
                    concatenatedValue = concatenatedValue + el.value;
                });
                this.$store.commit('setInput', {
                    categoryLabel: 'profile',
                    dataLabel: 'emailCode',
                    data: concatenatedValue,
                });
            },

            confirmEmailCode(){
                if(this.$store.state.input.profile.emailCode.length < 4){
                    this.$foneturkError({
                        text: 'Onay kodu 4 karakterden oluşmalıdır.',
                    });
                    return;
                }

                this.show.preloader = true;
                this.show.passwordConfirm = false;

                fetch(this.$store.state.jsonServer.passwordConfirmCode)
                .then(response => {
                    this.show.preloader = false;
                    return response.json();
                })
                .then(passwordConfirmData => {
                    if(passwordConfirmData.result){
                        this.show.passwordConfirm = false;
                        this.show.passwordSuccess = true;
                        clearInterval(this.intervals.emailConfirmation);
                        this.expireTime = '';
                    }
                    else{
                        this.show.passwordConfirm = true;
                        this.$nextTick(() => {
                            document.querySelectorAll('.profile-settings-password-confirm-form__inp-text').forEach((el, i) => {
                                if(this.$store.state.input.profile.emailCode[i]){
                                    el.value = this.$store.state.input.profile.emailCode[i];
                                }
                            });
                            document.querySelector('.profile-settings-password-confirm').classList.add('profile-settings-password-confirm--error');
                        });
                        this.$foneturkError({
                            text: 'Girdiğin kod yanlış.'
                        });
                    }
                })
            },

            confirmEmailCodeApi(){
                this.show.preloader = true;
                this.show.passwordConfirm = false;

                let passwordChangeConfirmationOptions = {
                    confirmationCode: this.$store.state.input.profile.emailCode,
                };

                fetch(this.$store.state.api.confirmPasswordChange, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: `passwordChangeConfirmationOptions=${JSON.stringify(passwordChangeConfirmationOptions)}`
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(passwordChangeConfirmationData => {
                    this.show.passwordConfirm = false;
                    this.show.passwordSuccess = true;
                    clearInterval(this.intervals.emailConfirmation);
                    this.expireTime = '';
                })
                .catch(err => {
                    this.show.passwordConfirm = true;
                    this.$nextTick(() => {
                        document.querySelectorAll('.profile-settings-password-confirm-form__inp-text').forEach((el, i) => {
                            if(this.$store.state.input.profile.emailCode[i]){
                                el.value = this.$store.state.input.profile.emailCode[i];
                            }
                        });
                        document.querySelector('.profile-settings-password-confirm').classList.add('profile-settings-password-confirm--error');
                    });
                    if(err.code == 'CONFIRM_PASSWORD_CHANGE_MODEL/RUN::PASSWORD_CHANGE_REQUEST_EXPIRED'){
                        this.$foneturkError({
                            text: 'Kodu girme süren doldu, yeni bir istek yap.'
                        });
                        return;
                    }
                    if(err.code == 'CONFIRM_PASSWORD_CHANGE_MODEL/RUN::CONFIRMATION_CODE_MISMATCH'){
                        this.$foneturkError({
                            text: 'Girdiğin kod yanlış.'
                        });
                        return;
                    }
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                })
            },

            requestPasswordReset(event){
                this.show.preloader = true;
                this.show.passwordChange = false;

                fetch(this.$store.state.jsonServer.passwordResetRequest)
                .then(response => {
                    this.show.preloader = false;
                    return response.json();
                })
                .then(resetRequestData => {
                    if(resetRequestData.result){
                        this.show.passwordForgot = true;
                    }
                    else{
                        this.show.passwordChange = true;
                        this.$foneturkError({
                            text: 'Bir şeyler ters gitti.'
                        });
                    }
                });
            },

            requestPasswordResetApi(){
                this.show.preloader = true;
                this.show.passwordChange = false;

                // Prepare the request body.
                let passwordResetRequestOptions = {
                    email: this.$store.state.userSession.email,
                };

                fetch(this.$store.state.api.requestPasswordReset, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    credentials: 'include',
                    body: `passwordResetRequestOptions=${JSON.stringify(passwordResetRequestOptions)}`
                })
                .then(async response => {
                    this.show.preloader = false;
                    if(response.status != 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(passwordResetRequestData => {
                    this.show.passwordForgot = true;
                })
                .catch(err => {
                    this.show.passwordChange = true;
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                })
            },

        }
    };
</script>
<style scoped src="@/css/components/profile-settings-password.css"></style>